import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { Box, Link as RebassLink, Flex, Container } from "theme-ui"
import footerLinks from "../constants/footerLinks"

export default (props) => (
  <Box
    as="footer"
    sx={{
      py: 5,
      color: "background",
      bg: "text",
      flexDirection: "row",
    }}
  >
    <Container
      sx={{
        px: 3,
        "& a": {
          color: "inherit",
        },
      }}
    >
      <Flex sx={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Box>
          Created by 
          <RebassLink
            href="https://swizec.com"
            variant="nav"
            style={{ textDecoration: "underline" }}
          >
            Swizec
          </RebassLink>
          with ❤️
        </Box>
        <Flex
          sx={{
            a: {
              marginLeft: 2,
            },
          }}
        >
          {footerLinks.map((link) => (
            <FooterLink key={link.Title} link={link} />
          ))}
        </Flex>
      </Flex>
    </Container>
  </Box>
)

function FooterLink({ link }) {
  if (link.Link.startsWith("http")) {
    return (
      <RebassLink href={link.Link} variant="nav">
        {link.Title}
      </RebassLink>
    )
  } else {
    return (
      <RebassLink as={GatsbyLink} key={link.Link} to={link.Link} variant="nav">
        {link.Title}
      </RebassLink>
    )
  }
}
